module.exports = __webpack_public_path__ + "static/media/elbow2Right.2eedc566.png";